import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/partner-field-school`;
const endpoints = {
    isAnnualPFSTargetSet: () => `${RESOURCE_ENDPOINT}/isAnnualPFSTargetSet`,
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getPfsMemberListByPfsId: (id: any) => `${RESOURCE_ENDPOINT}/pfs-member-list/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    pfsDropdownWithoutMember: () => `${RESOURCE_ENDPOINT}/pfsDropdownWithoutMember`,
    checkIsDuplicateEntry: () => `${RESOURCE_ENDPOINT}/checkIsDuplicateEntry`,
};

export default class PartnerFieldSchoolApi {
    public checkIsDuplicateEntry = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.checkIsDuplicateEntry();

        return HttpService.get(url, params, headers);
    };
    public isAnnualPFSTargetSet = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.isAnnualPFSTargetSet();

        return HttpService.get(url, params, headers);
    };

    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public pfsDropdownWithoutMember = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.pfsDropdownWithoutMember();
        return HttpService.get(url, params, headers);
    };

    public getPfsMemberListByPfsId = (id: any): AxiosPromise<any> => {
        const url = endpoints.getPfsMemberListByPfsId(id);
        return HttpService.get(url);
    };
}
